import { motion } from "framer-motion";
import { Globe, PhoneCall, Workflow, CreditCard, MessageSquare, CalendarDays, MapPin, Bot } from "lucide-react";

const ITEMS = [
  { icon: MapPin, label: "Google Business Profile" },
  { icon: PhoneCall, label: "Twilio Voice" },
  { icon: Bot, label: "OpenAI" },
  { icon: CreditCard, label: "Stripe" },
  { icon: Globe, label: "WordPress" },
  { icon: MessageSquare, label: "WhatsApp" },
  { icon: CalendarDays, label: "Calendly" },
  { icon: Workflow, label: "Zapier" },
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee-section" className="relative py-10 border-y border-white/5 bg-[#0A0D14]/60 overflow-hidden">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#07090E] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#07090E] to-transparent z-10" />
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        className="marquee-track flex w-max items-center gap-14 px-8"
      >
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-3 shrink-0 opacity-50 hover:opacity-100 transition-opacity duration-500">
            <item.icon className="h-5 w-5 text-cyan-400" />
            <span className="font-display text-lg font-semibold tracking-wide text-slate-300 whitespace-nowrap">
              {item.label}
            </span>
            <span className="ml-8 h-1 w-1 rounded-full bg-cyan-400/40" />
          </div>
        ))}
      </motion.div>
    </section>
  );
}
